import { render } from "./LookupUpload.vue?vue&type=template&id=6b1184ea"
import script from "./LookupUpload.vue?vue&type=script&lang=js"
export * from "./LookupUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__